module.exports = __webpack_public_path__ + "static/img/macOS_FAQ_pic19.a59c4db.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/macOS_FAQ/macOS_FAQ_pic19.png
// module id = 518
// module chunks = 1